function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9DADB2",
  d: "M233.639297,216.5 C255.102115,216.5 273.850215,228.081905 284.004782,245.329107 C284.142994,245.563856 284.279516,245.799488 284.414766,246.031276 C284.557977,245.802932 284.703979,245.576206 284.85275,245.351157 C290.871192,236.246953 301.189418,230.236938 312.920143,230.236938 C320.200733,230.236938 326.938853,232.550503 332.442028,236.482421 C338.097024,240.522812 342.44829,246.271698 344.744275,252.974687 C344.814764,253.180473 344.88317,253.386737 344.949627,253.593219 C345.124351,253.468884 345.302374,253.349775 345.483412,253.235962 C347.18125,252.168578 349.183912,251.542035 351.337408,251.542035 C354.384231,251.542035 357.14265,252.776991 359.139364,254.773621 C361.13607,256.770243 362.371077,259.528535 362.371077,262.57522 C362.371077,263.145842 362.314059,263.701949 362.230084,264.249139 C362.191838,264.498353 362.147703,264.747656 362.094963,264.996621 C362.342907,264.93213 362.591158,264.870426 362.839673,264.81149 C365.478479,264.185696 368.230814,263.852253 371.060486,263.852253 C378.598909,263.852253 385.588121,266.200845 391.336203,270.206122 C397.248945,274.326135 401.848705,280.198734 404.382197,287.07075 C404.467863,287.303117 404.550991,287.536148 404.632205,287.769221 C404.812554,287.601321 404.995415,287.436219 405.180713,287.27397 C409.409017,283.571628 414.942667,281.323267 421.005663,281.323267 C422.273052,281.323267 423.515768,281.423367 424.728879,281.612974 C430.306838,282.213707 435.348938,284.5183 439.344136,287.994725 C443.384372,291.51034 446.354223,296.224336 447.70003,301.583901 C447.751533,301.789007 447.800492,301.994402 447.847145,302.199599 C448.031131,302.099178 448.217046,302.00307 448.404705,301.911261 C450.2133,301.026433 452.237665,300.514546 454.386391,300.514546 C457.043021,300.514546 459.521063,301.274775 461.616261,302.58943 C463.555363,303.806142 465.16668,305.497444 466.288412,307.5 L466.288412,307.5 L25.9085043,307.5 C28.9199971,301.41064 33.5571208,296.268452 39.2540163,292.642901 C44.9814155,288.997938 51.780137,286.886249 59.0750876,286.886249 C68.0219947,286.886249 76.2278181,290.062113 82.6247743,295.347136 C85.7403949,293.287903 88.9236701,292.048482 92.3968155,292.048482 C94.9425101,292.048482 97.3311196,292.717142 99.4013305,293.882195 C99.7915168,294.10178 100.172499,294.340185 100.542501,294.596654 C100.383746,294.173304 100.246158,293.745622 100.129002,293.315154 C99.8022253,292.114474 99.6234703,290.851924 99.6234703,289.548342 C99.6234703,285.601545 101.223845,282.028241 103.811296,279.441654 C106.398728,276.855085 109.973219,275.255214 113.921535,275.255214 C117.31671,275.255214 120.434952,276.438361 122.886704,278.414805 C125.386161,280.429705 127.193309,283.268774 127.894846,286.519078 C134.307435,287.083748 139.895735,288.643047 144.814559,291.292244 C145.068546,291.429037 145.321089,291.56892 145.571805,291.710472 C145.559166,291.427003 145.552403,291.14041 145.551648,290.850728 C145.538367,285.752831 147.390703,281.601569 150.395299,278.597985 C153.396559,275.597735 157.542812,273.742158 162.122632,273.742158 C163.946265,273.742158 165.697958,274.040387 167.339297,274.584451 C167.551376,274.65475 167.762482,274.729441 167.972281,274.808341 C167.970824,274.58956 167.978355,274.369214 167.99518,274.147717 C168.144835,272.17757 169.007616,270.40848 170.326078,269.096834 C171.64427,267.785456 173.418049,266.931243 175.390572,266.790766 C177.933376,252.162407 185.126086,239.621029 195.501772,230.668107 C205.733964,221.839002 219.062042,216.5 233.639297,216.5 Z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 492,
  height: 1,
  x: 0.113,
  y: 307,
  fill: "#9DADB2",
  fillRule: "nonzero"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 184.785,
  cy: 40.5,
  stroke: "#073C50",
  rx: 57.5,
  ry: 26,
  transform: "rotate(-11 184.785 40.5)"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 194,
  cy: 74.81,
  fill: "#073C50",
  fillRule: "nonzero",
  rx: 140,
  ry: 46.5,
  transform: "rotate(-12 194 74.81)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#073C50",
  d: "M43.3678786,112.221065 C43.3678786,118.399487 46.4426559,124.339967 52.1128722,129.883688",
  transform: "rotate(-12 47.74 121.052)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#073C50",
  d: "M49.1191183,105.163193 C49.1191183,114.944301 56.968799,124.118029 70.6950112,132.030693",
  transform: "rotate(-12 59.907 118.597)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#073C50",
  d: "M325.470964,11.791288 C325.470964,17.9697104 328.545741,23.9101905 334.215957,29.4539115",
  transform: "rotate(153 329.843 20.623)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#073C50",
  d: "M307.938907,12.7095872 C307.938907,22.4906954 315.788588,31.6644225 329.5148,39.577087",
  transform: "rotate(153 318.727 26.143)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.113,
  cy: 80.514,
  r: 3,
  fill: "#FFF",
  fillRule: "nonzero"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 98.113,
  cy: 72.514,
  r: 3,
  fill: "#FFF",
  fillRule: "nonzero"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 74.113,
  cy: 89.514,
  r: 3,
  fill: "#FFF",
  fillRule: "nonzero"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 193.168,
  cy: 78.897,
  fill: "#E2FCA4",
  fillRule: "nonzero",
  rx: 62,
  ry: 21,
  transform: "rotate(-12 193.168 78.897)"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 193.168,
  cy: 78.897,
  stroke: "#073C50",
  rx: 54.5,
  ry: 16.5,
  transform: "rotate(-12 193.168 78.897)"
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#F7F7F7",
  fillRule: "nonzero",
  points: "183.458 99.814 159.113 308.27 319.172 308.27 207.309 94.164",
  opacity: 0.852
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 239,
  cy: 308.5,
  fill: "#DEDEDE",
  fillRule: "nonzero",
  rx: 80,
  ry: 15.5
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M189.352963,63.3521951 C203.640337,60.3153202 217.041439,59.5639175 227.307174,60.7960698 C228.555385,63.2923232 229.505185,65.9736682 230.108198,68.810622 C234.24195,88.2583981 220.513687,107.65426 199.445262,112.132492 C178.376838,116.610723 157.946438,104.47551 153.812685,85.0277339 C153.225086,82.2632987 152.998401,79.4999124 153.102409,76.780272 C162.0052,71.3488381 174.773551,66.4511449 189.352963,63.3521951 Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#073C50",
  fillRule: "nonzero",
  d: "M211.932404,169.201262 C215.896951,173.165809 216.39128,179.286472 213.415393,183.7887 L220.200333,190.573636 L216.919929,193.85404 L210.138266,187.072726 C205.634138,190.063648 199.500935,189.573834 195.530384,185.603283 C191.001091,181.07399 191.001091,173.730555 195.530384,169.201262 C200.059677,164.67197 207.403111,164.67197 211.932404,169.201262 Z M198.810788,172.481667 C196.093212,175.199242 196.093212,179.605303 198.810788,182.322879 C201.528364,185.040454 205.934424,185.040454 208.652,182.322879 C211.369576,179.605303 211.369576,175.199242 208.652,172.481667 C205.934424,169.764091 201.528364,169.764091 198.810788,172.481667 Z",
  transform: "rotate(-90 206.167 179.83)"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 206.113,
  y: 137.514,
  fill: "#073C50",
  fillRule: "nonzero",
  transform: "rotate(29 208.113 139.514)"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  x: 237.113,
  y: 194.88,
  stroke: "#073C50",
  transform: "rotate(120 239.613 197.38)"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 195.888,
  y: 225.807,
  fill: "#073C50",
  fillRule: "nonzero",
  transform: "rotate(-15 197.888 227.807)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#073C50",
  d: "M229.562992,252.052555 L252.656376,261.396598 C251.885796,269.662502 249.426005,278.148076 245.28163,286.854514 C241.14543,295.543778 235.250966,302.743532 227.59794,308.453531 L227.59794,308.453531 L197.263118,278.598814 C207.863487,276.704551 215.928972,273.024936 221.475565,267.587715 C226.97481,262.196909 229.641934,257.010903 229.562992,252.052555 L229.562992,252.052555 Z",
  transform: "rotate(1 224.96 280.253)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#073C50",
  fillRule: "nonzero",
  d: "M236.377545,229.149407 C233.460205,239.382217 227.807962,246.398248 219.420817,250.197499 C211.033672,253.996751 202.905578,255.486486 195.036535,254.666704 L219.49046,294.535896 C231.367629,293.164709 241.342806,288.089237 249.415991,279.309481 C257.489176,270.529725 263.760273,258.772179 268.22928,244.036845 L236.377545,229.149407 Z",
  transform: "rotate(-2 231.633 261.843)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#517684",
  fillRule: "nonzero",
  d: "M226.537955,257.143043 C228.352149,257.981909 230.648293,258.886168 233.426389,259.855819 C236.204486,260.82547 239.229727,261.649095 242.502114,262.326693 C242.447475,262.719003 242.40422,263.029577 242.372349,263.258415 C242.340478,263.487252 242.195045,263.79243 241.93605,264.173949 C236.942313,262.974671 233.573788,262.05447 231.830475,261.413346 C230.087162,260.772222 227.810187,259.854686 224.999549,258.660737 C225.119518,258.5755 225.236798,258.491983 225.351388,258.410187 L225.538549,258.274788 L225.551763,258.230386 C225.614412,258.059983 225.891786,257.744948 226.383884,257.285282 L226.537955,257.143043 Z M230.114967,251.108616 C232.576052,251.993792 235.681032,252.955797 239.429905,253.994629 C243.178779,255.033462 247.246543,255.931145 251.633199,256.687678 C251.585353,257.080891 251.547476,257.39218 251.519568,257.621543 C251.491659,257.850907 251.317804,258.154422 250.998001,258.532088 C244.293467,257.211444 239.763925,256.208763 237.409375,255.524047 C235.054825,254.839331 231.974456,253.864416 228.16827,252.599304 C228.399109,252.47488 228.622159,252.35421 228.837419,252.237295 L228.861549,252.223788 L228.871306,252.186472 C228.937709,252.015845 229.296046,251.696584 229.946318,251.228687 L230.114967,251.108616 Z M233.507711,245.629788 C236.011332,246.383777 239.16195,247.180483 242.959564,248.019908 C246.757179,248.859332 250.865926,249.540959 255.285807,250.064789 C255.258566,250.46 255.236885,250.772862 255.220766,251.003375 C255.204647,251.233888 255.046772,251.546169 254.74714,251.940217 C247.983299,250.97546 243.407961,250.213367 241.021125,249.653937 C238.63429,249.094507 235.507579,248.283608 231.640995,247.221241 C231.865064,247.084797 232.08155,246.952513 232.290452,246.82439 L232.313549,246.809788 L232.321656,246.771846 C232.379119,246.597947 232.720407,246.260198 233.345519,245.758601 L233.507711,245.629788 Z",
  transform: "rotate(13 240.143 254.902)"
});

var SvgNoSearchResult = function SvgNoSearchResult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 493 325",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoSearchResult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/No-Search-Result.65cf54f3.svg";
export { ForwardRef as ReactComponent };